import { Component, Input, OnInit } from '@angular/core';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';
import { FilterFiltersBase, IFilterFilters } from '../ifilter';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: '[app-purchasing-option-filter]',
  templateUrl: './purchasing-option-filter.component.html',
  styleUrls: ['./purchasing-option-filter.component.scss'],
  host: { 'class': 'control' },
  standalone: false
})
export class PurchasingOptionFilterComponent extends FilterFiltersBase implements OnInit, IFilterFilters {

  constructor(route: ActivatedRoute) {
    super(route);
  }

  public SelectedOption: string = "";
  public FilterName: string = "purchasingoption";
  public Filters: Datalistrequestfilter[] = [];
  @Input()
  public QueryParamPrefix: string = '';

  public options = [
    {id: 0, text: 'Users Can Purchase'},
    {id: 1, text: 'System Admin Must Grant'},
    {id: 2, text: 'Direct Purchase Link'},
  ];

  ngOnInit(): void {
    var vals = super.GetParamFields(this.QueryParamPrefix + this.FilterName);
    if(vals != null) {
      this.SelectedOption = vals[2];
    }

    if (this.SelectedOption != "") {
      this.Filters.push({
        Property: "PurchasingOption",
        Comparator: "==",
        Value: this.SelectedOption,
        FilterName: this.FilterName
      });
    }
  }

  public addPurchasingOptionFilter(event: any): void {
    var val = event?.target?.value;
    this.Filters = this.Filters.filter(x => x.Property != "PurchasingOption");

    if (val != "") {
      this.Filters.push({
        Property: "PurchasingOption",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName
      });
    }

    this.SelectedOption = val;
  }

  public PurchasingOptionSelected(purchasingoption: any) {

    if (purchasingoption == this.SelectedOption) {
      return true;
    }

    return false;
  }
}

